import { createFileRoute, Outlet } from '@tanstack/react-router';

import { backendApiOrganizationsFindOneOrganizationUserOptions } from '@/modules/api/backend/@tanstack/react-query.gen';

export const Route = createFileRoute(
  '/_authenticated/management/organizations/$organizationId/organizationUsers/$organizationUserId',
)({
  component: Outlet,
  beforeLoad: async ({ params: { organizationId, organizationUserId }, context: { queryClient } }) => {
    const organizationUser = await queryClient.ensureQueryData(
      backendApiOrganizationsFindOneOrganizationUserOptions({
        path: { organizationId, userId: organizationUserId },
      }),
    );

    return {
      breadcrumb: organizationUser?.user?.email,
    };
  },
});
